import React, {useState, useEffect} from 'react';


export default function Navbar() {
	
	const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

   const [width, setWidth] = useState(getWidth());

   useEffect(() => {
      setTimeout(function () {
         document.querySelector(".loader-wrapper").style = "display: none";
      }, 2000);

      // timeoutId for debounce mechanism
      let timeoutId = null;
      const resizeListener = () => {
        // prevent execution of previous setTimeout
        clearTimeout(timeoutId);
        // change width from the state object after 150 milliseconds
        timeoutId = setTimeout(() => setWidth(getWidth()), 150);
      };
      // set resize listener
      window.addEventListener('resize', resizeListener);
    
      // clean up function
      return () => {
        // remove resize listener
        window.removeEventListener('resize', resizeListener);
      }
    }, [])

	const [scrollPosition, setScrollPosition] = useState(0);
	const handleScroll = () => {
		const position = window.pageYOffset;
		setScrollPosition(position);
	};


	const state = { 'page_id': 1, 'user_id': 5 }
	const title = ''
	const url = 'index.html'

	

	const signInButtonStyle = width > 991 ? 
		{
			height: '40px',
			marginTop: '-3px',
			marginLeft:'8px'
		}
		:
		{
			height: '40px',
			margin:'16px'
		}

	return (
		<nav className="navbar navbar-expand-lg navbar-light theme-nav fixed-top">
			<div id="navbar-main" className="container">
				<a className="navbar-brand" href={`${process.env.PUBLIC_URL}/`}><img src="assets/images/logo.png" alt="logo" /></a>
				<button
					className="navbar-toggler never-focus"
					type="button"
					data-toggle="collapse"
					data-target="#navbarSupportedContent"
					aria-controls="navbarSupportedContent"
					aria-expanded="false"
					aria-label="Toggle navigation"
					style={{outline: 'none'}}
				>
					<span className="navbar-toggler-icon"></span>
				</button>
				{/* For some reason removing 'default-nav' fixed a bug where Home text wasn't showing. */}
				{/* <div className="collapse navbar-collapse default-nav" id="navbarSupportedContent"></div> */}
				<div className="collapse navbar-collapse" id="navbarSupportedContent">
					<ul className="navbar-nav ml-auto" id="mymenu">
						<li className="nav-item">
							<a className="nav-link" href="#home">Home</a>
						</li>
						<li className="nav-item">
							<a className="nav-link" href="#about">about</a>
						</li>
						<li className="nav-item">
							<a className="nav-link" href="#feature">features</a>
						</li>
						<li className="nav-item">
							<a className="nav-link" href="#screenshot">screenshots</a>
						</li>
						<li className="nav-item">
							<a className="nav-link" href="#team">team</a>
						</li>
						{/* <li className="nav-item dropdown">
							<a className="nav-link dropdown-toggle" href="#blog" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">blog</a>
							<ul className="dropdown-menu">
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/blog-list`} target="_blank">blog list</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/blog-details`} target="_blank">blog details</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/blog-leftside`} target="_blank">leftsidebar</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/blog-rightside`} target="_blank">rightsidebar</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/blog-left-sidebar`} target="_blank">details leftsidebar</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/blog-right-sidebar`} target="_blank">details rightsidebar</a></li>
							</ul>
						</li>
						<li className="nav-item">
							<a className="nav-link" href="#price" data-menuanchor="price">price</a>
						</li> */}
						<li className="nav-item">
							<a className="nav-link" href="#contact" data-menuanchor="contact">contact us</a>
						</li>
						{/* <li className="nav-item">
							<a className="hover-pointer nav-link" onClick={() => {
								window.history.pushState(state, title, url)
								window.location.replace("https://app.dropspin.io/")
							}}>sign in</a>
						</li> */}
						{width > 991 ? 
						<li className='nav-item'>
						<button
							type="button"
							className="btn btn-custom theme-color theme-color "
							style={signInButtonStyle}
							onClick= {()=> {
								window.history.pushState(state, title, url)
								window.location.replace("https://app.dropspin.io/")
							}}
							>
							Try For Free
						</button>
						</li>
						:
						<button
						type="button"
						className="btn btn-custom theme-color theme-color "
						style={signInButtonStyle}
						onClick= {()=> {
							window.history.pushState(state, title, url)
							window.location.replace("https://app.dropspin.io/")
						}}
						>
						Try For Free
					</button>
					}
						
						
						{/* <li className="nav-item dropdown">
							<a className="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Other page</a>
							<ul className="dropdown-menu">
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/sign-in`} target="_blank">sign in</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/sign-up`} target="_blank">sign up</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/forget-password`} target="_blank">Forget Password</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/thank-you`} target="_blank">Thank you</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/review`} target="_blank">Review</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/404`} target="_blank">404</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/faq`} target="_blank">FAQ</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/download`} target="_blank">Download</a></li>
								<li className="nav-item"><a className="nav-link" href={`${process.env.PUBLIC_URL}/coming-soon`} target="_blank">Coming Soon</a></li>
							</ul>
						</li> */}
					</ul>
				</div>
			</div>
		</nav>
	);
}



// WEBPACK FOOTER //
// ./src/components/navbar.js